import React from 'react'

export const LayoutLanding = props => (
  <div className={'app-wrapper landing-content'}>{props.children}</div>
)

export default LayoutLanding



// WEBPACK FOOTER //
// ./src/ui/shared/layout-landing.js